import {useQuery} from "@tanstack/react-query";
import type {CurrentUserFull} from "@/types/index";

export function useUser() {
  const {
    data: currentUser,
    isLoading: isLoadingUser,
    error,
  } = useQuery<CurrentUserFull>({
    queryKey: ["currentUser"],
    queryFn: async () => {
      const response = await fetch("/api/me");
      if (!response.ok) {
        throw new Error("Failed to fetch current user");
      }
      return response.json() as Promise<CurrentUserFull>;
    },
  });
  return {currentUser, isLoadingUser, error};
}
